<script>
  import Toasts from './Toasts.js';

  export default {
    name: 'TournToast',
    props: {
      message: Object,
      delay: Number,
    },
    data() {
      return {
        types: [
          'show',
          'info',
          'success',
          'error',
          'warning',
        ],
      };
    },
    mounted() {
      this.withDelay(this.delay).then(this.$nextTick).then(this.toast());
    },
    render() {
      return null;
    },
    computed: {
      type() {
        return Toasts.convert(this.message.level);
      },
    },
    methods: {
      toast() {
        this.type(this.message.message);
      },
      async withDelay(timeout) {
        await new Promise(r => setTimeout(r, timeout || 0));
      },
    },
  };
</script>
